export default __webpack_public_path__ + "static/media/Chevron_Right.e3039d21.svg";